import React, { useState, useEffect, useRef } from "react";

// const API_BASE_URL = "https://script.google.com/macros/s/AKfycbwfg4VUrPzPee72ce6p3JOaF7zxamIOl60d0oDdsdo6sMWW-WmVGaRMgHVjByqVyWmwDw/exec";
const API_BASE_URL =
  "https://script.google.com/macros/s/AKfycbzQhY3BspFrOxWFS0SXOlnyRBzsRNlnkqJPgXv4ISmeMeCX9FvdHoL9T2pFXqixqibYrw/exec";

// API Helper function
const apiCall = async (action, params = {}) => {
  try {
    const url = new URL(API_BASE_URL);
    url.searchParams.append("action", action);

    Object.keys(params).forEach((key) => {
      if (params[key] !== null && params[key] !== undefined) {
        url.searchParams.append(key, params[key]);
      }
    });

    const response = await fetch(url.toString());

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("API call error:", error);
    throw error;
  }
};

// Ticket Card Component
const TicketCard = ({ ticket, onOrderClick }) => {
  const priceFormatted = Number(ticket.Price).toLocaleString("id-ID");
  const isSoldOut = ticket.Stock <= 0;
  const stockInfo = isSoldOut ? "Habis Terjual" : `Sisa: ${ticket.Stock} tiket`;
  const defaultImageUrl = `https://via.placeholder.com/300x170/E0E0E0/B0B0B0?text=Event`;

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden min-w-80 mx-2 flex-shrink-0">
      <div className="h-44 overflow-hidden">
        <img
          src={ticket.ImageURL || defaultImageUrl}
          alt={`Poster ${ticket.EventName}`}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = defaultImageUrl;
          }}
        />
      </div>
      <div className="p-4">
        <div className="mb-4">
          <h4 className="font-semibold text-lg mb-2">
            {ticket.EventName} - {ticket.Category}
          </h4>
          <p className="text-xl font-bold text-green-600 mb-2">
            Rp {priceFormatted}
          </p>
          <p
            className="text-gray-600 text-sm mb-2"
            dangerouslySetInnerHTML={{
              __html: ticket.Description || "Deskripsi tiket tidak tersedia.",
            }}
          ></p>
          <p className="text-sm font-medium text-gray-700">{stockInfo}</p>
        </div>
        <button
          onClick={() =>
            onOrderClick(
              ticket.ID,
              `${ticket.EventName} - ${ticket.Category}`,
              ticket.Price
            )
          }
          disabled={isSoldOut}
          className={`w-full py-2 px-4 rounded font-medium ${
            isSoldOut
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-blue-600 text-white hover:bg-blue-700 transition-colors"
          }`}
        >
          {isSoldOut ? "Habis Terjual" : "Pesan Tiket Ini"}
        </button>
      </div>
    </div>
  );
};

// Order Form Component
const OrderForm = ({
  isVisible,
  selectedTicket,
  onSubmit,
  onCancel,
  loading,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    quantity: 1,
  });
  const [errors, setErrors] = useState([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = [];

    if (!formData.name.trim()) newErrors.push("Nama lengkap wajib diisi.");

    if (!formData.email.trim()) {
      newErrors.push("Alamat email wajib diisi.");
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email))
        newErrors.push("Format alamat email tidak valid.");
    }

    if (!formData.phone.trim()) {
      newErrors.push("Nomor HP wajib diisi.");
    } else if (!/^08\d{8,12}$/.test(formData.phone)) {
      newErrors.push(
        "Nomor HP harus diawali 08 dan terdiri dari 10-14 digit angka."
      );
    }

    if (isNaN(formData.quantity) || formData.quantity < 1) {
      newErrors.push("Jumlah tiket minimal 1 buah.");
    }

    return newErrors;
  };

  const handleSubmit = () => {
    const validationErrors = validateForm();

    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors([]);
    onSubmit(formData);
  };

  const handleCancel = () => {
    setFormData({ name: "", email: "", phone: "", quantity: 1 });
    setErrors([]);
    onCancel();
  };

  if (!isVisible) return null;

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mt-6">
      <h3 className="text-xl font-semibold mb-4">📝 Form Pemesanan</h3>

      {errors.length > 0 && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          <p className="font-semibold">Mohon perbaiki kesalahan berikut:</p>
          <ul className="list-disc list-inside mt-2">
            {errors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </div>
      )}

      <div className="space-y-4">
        <input
          type="text"
          name="name"
          placeholder="Nama Lengkap Anda"
          value={formData.name}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          required
        />

        <input
          type="email"
          name="email"
          placeholder="Alamat Email Aktif"
          value={formData.email}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          required
        />

        <input
          type="tel"
          name="phone"
          placeholder="Nomor HP (cth: 081234567890)"
          value={formData.phone}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          required
        />

        <input
          type="number"
          name="quantity"
          placeholder="Jumlah Tiket"
          min="1"
          value={formData.quantity}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          required
        />

        <div className="flex gap-4">
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="flex-1 bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50"
          >
            {loading ? "Memproses..." : "Lanjutkan ke Pembayaran"}
          </button>
        </div>
      </div>
    </div>
  );
};

// Payment Status Component
const PaymentStatusChecker = () => {
  const [orderId, setOrderId] = useState("");
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);

  const checkPayment = async () => {
    if (!orderId.trim()) {
      setResult(
        '<div class="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">⚠️ Harap masukkan Order ID Anda terlebih dahulu.</div>'
      );
      return;
    }

    setLoading(true);
    setResult(
      `<p class="text-blue-600">🔍 Sedang memeriksa status pembayaran untuk Order ID: <strong>${orderId}</strong>...</p>`
    );

    try {
      const result = await apiCall("checkPayment", { orderId: orderId });

      let message = "";
      let bgColor = "bg-yellow-100 border-yellow-400 text-yellow-700";

      if (result && result.success && result.data) {
        const data = result.data;

        if (
          data.status === "PAID" ||
          data.message.toLowerCase().includes("berhasil") ||
          data.message.toLowerCase().includes("sudah dilakukan")
        ) {
          message = `✅ Pembayaran untuk Order ID <strong>${orderId}</strong> telah berhasil dikonfirmasi. Tiket Anda akan segera dikirim melalui email.`;
          bgColor = "bg-green-100 border-green-400 text-green-700";
          setOrderId("");
        } else if (
          data.status === "PENDING" ||
          data.message.toLowerCase().includes("pending")
        ) {
          message = `⏳ Pembayaran untuk Order ID <strong>${orderId}</strong> masih menunggu konfirmasi. Mohon tunggu beberapa saat dan coba cek kembali.`;
        } else if (
          data.status === "FAILED" ||
          data.message.toLowerCase().includes("gagal")
        ) {
          message = `❌ Pembayaran untuk Order ID <strong>${orderId}</strong> gagal atau belum dilakukan. ${
            data.message || ""
          }`;
          bgColor = "bg-red-100 border-red-400 text-red-700";
        } else {
          message = `ℹ️ Status untuk Order ID <strong>${orderId}</strong>: ${
            data.message || data.status
          }`;
        }
      } else {
        message = `ℹ️ Tidak ada informasi status untuk Order ID <strong>${orderId}</strong>.`;
      }

      setResult(
        `<div class="${bgColor} border px-4 py-3 rounded">${message}</div>`
      );
    } catch (error) {
      setResult(
        `<div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">❌ Terjadi kesalahan saat memeriksa status pembayaran: ${
          error.message || error
        }</div>`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mt-6">
      <h3 className="text-xl font-semibold mb-4">💳 Cek Status Pembayaran</h3>
      <p className="mb-4">
        Sudah melakukan pembayaran? Masukkan Order ID Anda untuk mengecek
        status:
      </p>

      <div className="flex flex-col sm:flex-row gap-4 mb-4">
        <input
          type="text"
          placeholder="Masukkan Order ID (misal: ORD1234567890)"
          value={orderId}
          onChange={(e) => setOrderId(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        <button
          onClick={checkPayment}
          disabled={loading}
          className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50"
        >
          {loading ? "Mengecek..." : "Cek Status"}
        </button>
      </div>

      {result && <div dangerouslySetInnerHTML={{ __html: result }} />}
    </div>
  );
};

// Ticket Verification Component
const TicketVerification = () => {
  const [code, setCode] = useState("");
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);

  const verify = async () => {
    if (!code.trim()) {
      setResult(
        '<div class="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">⚠️ Harap masukkan kode tiket atau hasil scan QR terlebih dahulu.</div>'
      );
      return;
    }

    setLoading(true);
    setResult(
      "<p class='text-blue-600'>🔍 Sedang memverifikasi kode tiket...</p>"
    );

    try {
      const result = await apiCall("verifyTicket", {
        uniqueCode: code,
        verifiedBy: "Panitia",
      });

      let messageText = "";
      let bgColor = "bg-yellow-100 border-yellow-400 text-yellow-700";

      if (result && result.success && result.data) {
        const data = result.data;
        messageText = data.message || "Verifikasi berhasil";

        if (data.success || data.message.toLowerCase().includes("berhasil")) {
          bgColor = "bg-green-100 border-green-400 text-green-700";
          setCode("");
        } else if (
          data.message.toLowerCase().includes("gagal") ||
          data.message.toLowerCase().includes("tidak ditemukan") ||
          data.message.toLowerCase().includes("sudah digunakan")
        ) {
          bgColor = "bg-red-100 border-red-400 text-red-700";
        }
      } else {
        messageText = result.message || "Respons verifikasi tidak dikenali.";
        bgColor = "bg-red-100 border-red-400 text-red-700";
      }

      const icon = bgColor.includes("green")
        ? "✅"
        : bgColor.includes("red")
        ? "❌"
        : "ℹ️";
      setResult(
        `<div class="${bgColor} border px-4 py-3 rounded">${icon} ${messageText}</div>`
      );
    } catch (error) {
      setResult(
        `<div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">❌ Terjadi kesalahan saat verifikasi: ${
          error.message || error
        }</div>`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mt-6">
      <h3 className="text-xl font-semibold mb-4">
        ✅ Verifikasi Tiket (Khusus Panitia)
      </h3>
      <p className="mb-4">
        Scan QR Code tiket atau masukkan kode unik untuk melakukan verifikasi:
      </p>

      <div className="flex flex-col sm:flex-row gap-4 mb-4">
        <input
          type="text"
          placeholder="Kode tiket atau hasil scan QR"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        <button
          onClick={verify}
          disabled={loading}
          className="w-full sm:w-auto bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50"
        >
          {loading ? "Memverifikasi..." : "Verifikasi Tiket"}
        </button>
      </div>

      {result && <div dangerouslySetInnerHTML={{ __html: result }} />}
    </div>
  );
};

// Main App Component
const TicketBookingApp = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [orderStatus, setOrderStatus] = useState("");
  const [orderLoading, setOrderLoading] = useState(false);
  const [currentOrderId, setCurrentOrderId] = useState(null);

  const ticketListRef = useRef(null);

  // Load tickets on component mount
  useEffect(() => {
    loadTickets();
  }, []);

  const loadTickets = async () => {
    try {
      setLoading(true);
      const response = await apiCall("getTickets");

      if (response.success && response.data) {
        setTickets(response.data);
        setError("");
      } else {
        throw new Error("Failed to get tickets data");
      }
    } catch (error) {
      setError(`Gagal memuat tiket: ${error.message || error}`);
      setTickets([]);
    } finally {
      setLoading(false);
    }
  };

  const handleOrderClick = (ticketId, eventName, price) => {
    setSelectedTicket({ id: ticketId, name: eventName, price });
    setShowOrderForm(true);
    setOrderStatus(`
      <div class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
        <p style="font-size: 1.1em; font-weight: 600; margin-bottom: 10px;">Anda memilih tiket untuk:</p>
        <p><strong>Event:</strong> ${eventName}</p>
        <p><strong>Harga per tiket:</strong> Rp ${Number(price).toLocaleString(
          "id-ID"
        )}</p>
        <p style="margin-top:10px; font-style:italic; font-size:0.9em;">Silakan lengkapi form pemesanan di bawah ini.</p>
      </div>
    `);
  };

  const handleOrderSubmit = async (formData) => {
    setOrderLoading(true);
    setOrderStatus(
      "<p class='text-blue-600'>⏳ Sedang memproses pesanan Anda, mohon tunggu...</p>"
    );

    const formDataToSend = new FormData();
    formDataToSend.append("action", "createOrder");
    formDataToSend.append("ticketId", selectedTicket.id);
    formDataToSend.append("name", formData.name);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("phone", formData.phone);
    formDataToSend.append("quantity", formData.quantity);

    try {
      const response = await fetch(API_BASE_URL, {
        method: "POST",
        body: formDataToSend,
      });

      const result = await response.json();

      if (result && result.success && result.data) {
        const data = result.data;

        if (data.qrisUrl && data.orderId) {
          setCurrentOrderId(data.orderId);

          setOrderStatus(`
            <div class="bg-blue-50 border border-blue-200 rounded-lg p-6 text-center">
              <h3 class="text-xl font-semibold mb-4">📱 Scan QRIS Ini untuk Pembayaran</h3>
              <img src="${data.qrisUrl}" alt="QR Code QRIS Pembayaran" class="mx-auto mb-4 max-w-64">
              <p class="mb-2"><strong>Order ID Anda:</strong> <span class="font-mono bg-gray-100 px-2 py-1 rounded">${data.orderId}</span></p>
              <p class="text-red-600 font-medium mb-2">PENTING: Harap simpan Order ID ini untuk mengecek status pembayaran Anda.</p>
              <p class="text-gray-600">Setelah pembayaran berhasil, tunggu beberapa saat, lalu cek status pembayaran menggunakan fitur di bawah.</p>
            </div>
          `);

          setShowOrderForm(false);
        } else {
          setOrderStatus(
            `<div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">❌ Gagal membuat pesanan. ${
              data.message || "Data tidak lengkap dari server."
            }</div>`
          );
        }
      } else {
        setOrderStatus(
          `<div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">❌ Gagal membuat pesanan. ${
            result.message || "Respon dari server tidak dikenali."
          }</div>`
        );
      }
    } catch (error) {
      setOrderStatus(
        `<div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">❌ Terjadi kesalahan teknis saat memproses pesanan: ${
          error.message || error
        }. Mohon coba beberapa saat lagi.</div>`
      );
    } finally {
      setOrderLoading(false);
    }
  };

  const handleOrderCancel = () => {
    setShowOrderForm(false);
    setSelectedTicket(null);
    setOrderStatus("");
  };

  const scrollCarousel = (direction) => {
    if (ticketListRef.current) {
      const scrollAmount = 340 * direction; // width + margin
      ticketListRef.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-4">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">
            🎫 Tiket Event Tersedia
          </h2>

          <div className="flex gap-2">
            <button
              onClick={() => scrollCarousel(-1)}
              className="bg-white hover:bg-gray-50 border border-gray-300 px-3 py-2 rounded-lg shadow-sm"
              title="Sebelumnya"
            >
              &lt;
            </button>
            <button
              onClick={() => scrollCarousel(1)}
              className="bg-white hover:bg-gray-50 border border-gray-300 px-3 py-2 rounded-lg shadow-sm"
              title="Berikutnya"
            >
              &gt;
            </button>
          </div>
        </div>

        {/* Tickets Carousel */}
        <div className="mb-8">
          {loading ? (
            <div className="text-center py-12">
              <p className="text-gray-600">Memuat tiket tersedia...</p>
            </div>
          ) : error ? (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
              <p>{error}</p>
            </div>
          ) : tickets.length === 0 ? (
            <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">
              <p>
                Tidak ada tiket tersedia saat ini. Silakan cek kembali nanti.
              </p>
            </div>
          ) : (
            <div
              ref={ticketListRef}
              className="flex overflow-x-auto gap-4 pb-4 scrollbar-hide"
              style={{ scrollSnapType: "x mandatory" }}
            >
              {tickets.map((ticket) => (
                <TicketCard
                  key={ticket.ID}
                  ticket={ticket}
                  onOrderClick={handleOrderClick}
                />
              ))}
            </div>
          )}
        </div>

        {/* Order Status */}
        {orderStatus && (
          <div className="mb-6">
            <div dangerouslySetInnerHTML={{ __html: orderStatus }} />
          </div>
        )}

        {/* Order Form */}
        <OrderForm
          isVisible={showOrderForm}
          selectedTicket={selectedTicket}
          onSubmit={handleOrderSubmit}
          onCancel={handleOrderCancel}
          loading={orderLoading}
        />

        {/* Payment Status Checker */}
        <PaymentStatusChecker />

        {/* Divider */}
        <hr className="my-8 border-gray-300" />

        {/* Ticket Verification */}
        <TicketVerification />
      </div>
    </div>
  );
};

export default TicketBookingApp;
